import { Subscription } from '@innovyze/shared-utils';
import { useEntitlements, useIsFeatureEnabled } from '@innovyze/stylovyze';
import {
  prepareResolutionOptions,
  getClosestResolutionForUser,
  ResolutionOption,
} from '../../utils/resolutions.utils';

export function useFilteredResolutions() {
  const { hasEntitlement } = useEntitlements();
  const isChartsLimitationEnabled = useIsFeatureEnabled(
    'i360i-release-capacity-pricing'
  );

  const getFilteredResolutionOptions = (
    options: ResolutionOption[],
    current?: ResolutionOption['value']
  ) => {
    if (!isChartsLimitationEnabled) return options;
    const isUserAdvanced = hasEntitlement(Subscription.I360IADVRU);
    const resolutionUserType = isUserAdvanced ? 'advanced' : 'standard';
    return prepareResolutionOptions(options, resolutionUserType, current);
  };

  const getDefaultResolution = (
    selectedOption: ResolutionOption['value'],
    availableOptions: ResolutionOption[]
  ) => {
    if (!isChartsLimitationEnabled) return selectedOption;
    const isUserAdvanced = hasEntitlement(Subscription.I360IADVRU);
    const optionValues = availableOptions.map((opt) => opt.value);
    const resolutionUserType = isUserAdvanced ? 'advanced' : 'standard';
    return getClosestResolutionForUser(
      selectedOption,
      optionValues,
      resolutionUserType
    );
  };

  return { getFilteredResolutionOptions, getDefaultResolution };
}
